import React from 'react'
import { useNavigate } from 'react-router-dom';

function ECLoginForm() {
    const navigate = useNavigate();

    return (
        <div className='ec-landing-login-col-2'>
            <div className="w-full bg-white shadow-[0_-4px_24px_3px_#00000040]  rounded-3xl	p-20">
                <div className=' flex  justify-center pb-12'>
                    <span className='text-primaryPink text-center text-3xl font-semibold '>Log In</span>
                </div>
                <div className="flex gap-6 flex-col pb-14">
                    <div className=" flex flex-col  gap-3">
                        <label className='text-sm font-normal text-fieldTextColor rounded-xl '>Email ID</label>
                        <input type="email" className="border border-secondaryColor w-80 p-4 rounded-xl text-base text-inputTextColor" name="emailId"
                            placeholder='Enter your Email ID' />
                    </div>

                    <div className=" flex flex-col   gap-3" >
                        <label className='text-fieldTextColor  pt-3'>Password</label>
                        <input type="password" className="border border-secondaryColor w-80 p-4 rounded-xl text-base text-inputTextColor " name="password"
                            placeholder='Enter your password' />
                    </div>

                    <div className='text-center underline underline-offset-1'>
                        <span className='text-secondaryColor xl:text-bodyText ' onClick={() => navigate("/ec/reset-password")}>Forgot password?</span>
                    </div> 

                    <div >
                        <button className='bg-secondaryColor text-white rounded-full w-full pt-2 pb-2' >Login</button>
                    </div>
                </div>

                <div className="text-center " >
                    <span className='text-secondaryColor'>Don’t have an account? <span className='text-primaryPink underline underline-offset-1' onClick={() => navigate("/ec/signup/915432167890/Organic")}>Sign Up</span></span>
                </div>
            </div>
        </div>
    )
}

export default ECLoginForm;
